import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ReduxState } from '../../types/redux';
import { getCookie, setCookie } from '../../utils/helpers/cookies';

const NEW_APP_LINK_POPUP_COOKIE = 'newManagerPortalPopupDismissed';

function NewAppLink(): JSX.Element | null {
  const { t } = useTranslation();

  const refreshToken = useSelector<
    ReduxState,
    ReduxState['user']['refresh_token']
  >((state) => state.user?.refresh_token);

  const newManagerAppUrl = process.env.REACT_APP_NEW_MANAGER_URL;

  const [isPopupVisible, setPopupVisible] = useState(false);

  useEffect(() => {
    if (!newManagerAppUrl || getCookie(NEW_APP_LINK_POPUP_COOKIE)) {
      return;
    }

    setPopupVisible(true);
  }, [newManagerAppUrl]);

  const dismissPopup = useCallback(() => {
    setPopupVisible(false);

    const tomorrowMidnight = new Date();
    tomorrowMidnight.setDate(tomorrowMidnight.getDate() + 1);
    tomorrowMidnight.setHours(0, 0, 0, 0);

    setCookie(NEW_APP_LINK_POPUP_COOKIE, '1', { expires: tomorrowMidnight });
  }, []);

  if (!newManagerAppUrl) {
    return null;
  }

  const href = `${newManagerAppUrl}#refresh_token=${encodeURIComponent(
    refreshToken ?? ''
  )}`;

  return (
    <span className="new-app-link-wrapper">
      <Tooltip target=".new-app-link" />
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="new-app-link"
        data-pr-tooltip={t('Try our new manager portal')}
        data-pr-position="bottom"
      >
        <FontAwesomeIcon icon={faExternalLinkAlt} />
      </a>

      {isPopupVisible && (
        <div className="new-app-link-popup">
          <p>{t('Here you can try the new manager portal')}</p>
          <Button
            label={t('OK')}
            onClick={dismissPopup}
            className="p-button-sm"
          />
        </div>
      )}
    </span>
  );
}

export default NewAppLink;
